import { IconToggleHeartOff16, IconToggleHeartOn16 } from '@cian/ui-kit-design-tokens/icons';

import { type ReactNode, type SyntheticEvent, useCallback } from 'react';

import { useCardOfferContext } from '@/microfrontends/listing/shared/context/selectors';

import { CustomRoundButton } from '@/packages/shared-ui';
import { stopPropagation } from '@/packages/utils/event';

import { useToggleFavorite } from '../../../hooks/card/useToggleFavorite';

export function FavoritesActionButtonContainer(): ReactNode {
  const {
    data: {
      extendedProperties: { isFavorite },
    },
  } = useCardOfferContext();

  const toggleFavorite = useToggleFavorite();

  const handleToggleFavorite = useCallback(
    (e: SyntheticEvent) => {
      stopPropagation(e);
      toggleFavorite();
    },
    [toggleFavorite],
  );

  return (
    <CustomRoundButton
      data-testid="FavoritesControl"
      icon={isFavorite ? <IconToggleHeartOn16 color="error_100" /> : <IconToggleHeartOff16 color="current_color" />}
      title={isFavorite ? 'Удалить из избранного' : 'Добавить в избранное'}
      onClick={handleToggleFavorite}
    />
  );
}
